export default "__VITE_ASSET__OunJt85w__"